import { render, staticRenderFns } from "./RightColumnGroup.vue?vue&type=template&id=06787e5a&scoped=true&"
import script from "./RightColumnGroup.vue?vue&type=script&lang=js&"
export * from "./RightColumnGroup.vue?vue&type=script&lang=js&"
import style0 from "./RightColumnGroup.vue?vue&type=style&index=0&id=06787e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06787e5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
